<div class="banner" *ngIf="isIeLessThan10 && isBannerShown">
  <!-- <span class="banner-close" (click)="isBannerShown = !isBannerShown">X</span> -->
  <div class="banner-message">
    Please switch to a modern browser such as Google Chrome or Mozilla Firefox for a better experience, enhanced speed
    and up to date security.
  </div>
</div>
